import { Model } from '@vuex-orm/core';


export default class Device extends Model {
  static entity = 'devices'
  static primaryKey = 'serial'

  static fields() {

    return {
      serial: this.string(''),
      name: this.string(''),
      location: this.string(''),
      heartbeat: this.string(null).nullable()
    };
  }
}
